const solutionType = {
	ACCEPT: 'ACCEPT',
	SOLUTION_DECLINE: 'DECLINE',
	ACCEPT_PERCENT: 'ACCEPT_PERCENT',
}

export default solutionType
